/**
 * AVERO — High-Fashion Noir Theme
 * Main JavaScript
 */

(function () {
  'use strict';

  // =========================================
  // UTILITY
  // =========================================

  function debounce(fn, delay) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn.apply.bind(fn, this, arguments), delay);
    };
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = (cents / 100).toFixed(2);
    return '\u20B9' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getJSON(url, callback) {
    fetch(url, {
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(callback)
      .catch(function (err) { console.error('[Avero] Fetch error:', err); });
  }

  // =========================================
  // HEADER — Scroll Transparency
  // =========================================

  var headerWrapper = document.querySelector('.site-header-wrapper');

  function handleHeaderScroll() {
    if (!headerWrapper) return;
    if (window.scrollY > 10) {
      headerWrapper.classList.add('is-scrolled');
    } else {
      headerWrapper.classList.remove('is-scrolled');
    }
  }

  if (headerWrapper) {
    window.addEventListener('scroll', handleHeaderScroll, { passive: true });
    handleHeaderScroll();
  }

  // =========================================
  // MOBILE MENU
  // =========================================

  var mobileToggle = document.querySelector('.js-mobile-toggle');
  var mobileClose = document.querySelector('.js-mobile-close');
  var mobileMenu = document.querySelector('.mobile-menu');
  var mobileDropdownToggles = document.querySelectorAll('.js-mobile-dropdown');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileToggle) { mobileToggle.classList.add('is-open'); mobileToggle.setAttribute('aria-expanded', 'true'); }
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileToggle) { mobileToggle.classList.remove('is-open'); mobileToggle.setAttribute('aria-expanded', 'false'); }
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);

  mobileDropdownToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var submenu = toggle.nextElementSibling;
      if (submenu) {
        submenu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', submenu.classList.contains('is-open').toString());
      }
    });
  });

  // =========================================
  // SCROLL REVEAL — Intersection Observer
  // =========================================

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
  );

  document.querySelectorAll('.reveal').forEach(function (el) {
    revealObserver.observe(el);
  });

  // =========================================
  // CART DRAWER
  // =========================================

  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer-overlay');
  var cartBody = document.querySelector('.cart-drawer-body');
  var cartFooter = document.querySelector('.cart-drawer-footer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    cartDrawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  function refreshCartDrawer() {
    if (!cartBody) return;
    cartBody.innerHTML = '<div class="cart-loading"><div class="cart-loading-spinner"></div></div>';

    getJSON('/cart.js', function (cart) {
      renderCartDrawer(cart);
    });
  }

  function renderCartDrawer(cart) {
    if (!cartBody) return;

    var countEl = document.querySelector('.js-cart-drawer-count');
    if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');

    // Update all cart count badges
    document.querySelectorAll('.js-cart-badge, .cart-badge, .cart-count-badge').forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<div class="cart-empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm6.75 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/></svg>' +
        '<p>Your bag is empty</p>' +
        '<a href="/collections/all" class="btn btn-outline" onclick="closeCartDrawer()">Continue Shopping</a>' +
        '</div>';

      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    if (cartFooter) cartFooter.style.display = 'block';

    var itemsHTML = cart.items.map(function (item) {
      var imgSrc = item.image ? item.image.replace('http:', 'https:') : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var max = (window.averoInventoryMax && window.averoInventoryMax(item.variant_id));
      var maxAttr = (max != null) ? (' max="' + max + '" data-max="' + max + '"') : '';

      return '<div class="cart-item" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" class="cart-item-image" width="80" height="100">' : '') +
        '<div class="cart-item-details">' +
        '<div class="cart-item-vendor">' + (item.vendor || '') + '</div>' +
        '<div class="cart-item-title">' + item.product_title + '</div>' +
        (variantTitle ? '<div class="cart-item-variant">' + variantTitle + '</div>' : '') +
        '<div class="cart-item-price-row">' +
        '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-item-qty">' +
        '<button class="cart-item-qty-btn js-qty-minus" data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
        '<input class="cart-item-qty-input" type="number" value="' + item.quantity + '" min="0"' + maxAttr + ' data-key="' + item.key + '" data-variant-id="' + item.variant_id + '" aria-label="Quantity">' +
        '<button class="cart-item-qty-btn js-qty-plus" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '</div>' +
        '<button class="cart-item-remove js-remove-item" data-key="' + item.key + '" aria-label="Remove item">Remove</button>' +
        '</div>' +
        '</div>';
    }).join('');

    cartBody.innerHTML = itemsHTML;

    // Update subtotal
    var subtotalEl = document.querySelector('.js-cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Update free shipping progress bar — read threshold from liquid (data-threshold on .js-shipping-progress)
    var progressEl = document.querySelector('.js-shipping-progress');
    var threshold = progressEl ? (parseInt(progressEl.getAttribute('data-threshold'), 10) || 99900) : 99900;
    var remaining = threshold - cart.total_price;
    var progressMsg = document.querySelector('.shipping-progress-msg');
    var progressFill = document.querySelector('.js-shipping-fill');
    if (cart.total_price >= threshold) {
      if (progressMsg) { progressMsg.classList.add('shipping-unlocked'); progressMsg.innerHTML = '🎉 You\'ve unlocked <strong>Free Shipping!</strong>'; }
      if (progressFill) progressFill.style.width = '100%';
    } else {
      var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
      if (progressMsg) { progressMsg.classList.remove('shipping-unlocked'); progressMsg.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for <strong>Free Shipping</strong>'; }
      if (progressFill) progressFill.style.width = pct + '%';
    }

    attachCartItemEvents();
  }

  function attachCartItemEvents() {
    cartBody.querySelectorAll('.js-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var input = cartBody.querySelector('.cart-item-qty-input[data-key="' + key + '"]');
        if (input) {
          var newVal = Math.max(0, parseInt(input.value, 10) - 1);
          updateCartItem(key, newVal);
        }
      });
    });

    cartBody.querySelectorAll('.js-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var input = cartBody.querySelector('.cart-item-qty-input[data-key="' + key + '"]');
        if (!input) return;
        var newVal = parseInt(input.value, 10) + 1;
        var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
        if (max != null && newVal > max) {
          if (window.averoToast) window.averoToast(max === 0 ? 'Out of stock' : 'Only ' + max + ' available', 'error');
          return;
        }
        updateCartItem(key, newVal);
      });
    });

    cartBody.querySelectorAll('.cart-item-qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-key');
        var newVal = Math.max(0, parseInt(input.value, 10) || 0);
        var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
        if (max != null && newVal > max) {
          if (window.averoToast) window.averoToast(max === 0 ? 'Out of stock' : 'Only ' + max + ' available', 'error');
          newVal = max;
          input.value = max;
        }
        updateCartItem(key, newVal);
      });
    });

    cartBody.querySelectorAll('.js-remove-item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        updateCartItem(key, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function (err) { console.error('[Avero] Cart update error:', err); });
  }

  // Cart trigger buttons — look up the drawer lazily at click time so that
  // a late-mounted drawer (or a re-rendered section) still works. Always give
  // the click somewhere to go: open the drawer if we can, otherwise navigate
  // to the full cart page as a guaranteed fallback.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-cart-drawer-trigger');
    if (trigger) {
      // Refresh the cached references in case the drawer was (re)rendered
      // after this script first ran.
      cartDrawer  = cartDrawer  || document.querySelector('.cart-drawer');
      cartOverlay = cartOverlay || document.querySelector('.cart-drawer-overlay');
      cartBody    = cartBody    || document.querySelector('.cart-drawer-body');
      cartFooter  = cartFooter  || document.querySelector('.cart-drawer-footer');

      if (cartDrawer) {
        e.preventDefault();
        openCartDrawer();
      } else if (trigger.tagName !== 'A') {
        // No drawer in the DOM and no href to fall back on — take the user
        // to the full cart page manually so the button is never a dead end.
        e.preventDefault();
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
      }
      // If it's an <a>, letting the default action run navigates to /cart.
      return;
    }

    if (e.target.closest('.cart-drawer-close') || e.target.closest('.js-cart-drawer-overlay')) {
      closeCartDrawer();
    }
  });

  // Add to Cart — intercept forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Added!';
          setTimeout(function () {
            submitBtn.textContent = submitBtn.getAttribute('data-original-text') || 'Add to Bag';
          }, 2000);
        }
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[Avero] ATC error:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-original-text') || 'Add to Bag';
        }
      });
  });

  // Quick-Add behaviour is handled in layout/theme.liquid (with toast + dedupe).
  // Open the cart drawer after a successful add.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-quick-add');
    if (!btn) return;
    // The inline handler in theme.liquid uses fetch().then — once the cart
    // updates, refresh the drawer count and open it.
    setTimeout(function () {
      getJSON('/cart.js', function (cart) {
        document.querySelectorAll('.js-cart-badge, .cart-badge, .cart-count-badge').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
    }, 600);
  });

  // =========================================
  // COUNTDOWN TIMER
  // =========================================

  var countdownElements = document.querySelectorAll('[data-countdown]');

  countdownElements.forEach(function (el) {
    var targetDate = new Date(el.getAttribute('data-countdown')).getTime();

    function tick() {
      var now = Date.now();
      var diff = targetDate - now;

      if (diff <= 0) {
        el.innerHTML = '<span style="color:var(--color-muted)">Drop has ended</span>';
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((diff % (1000 * 60)) / 1000);

      var dd = el.querySelector('.js-countdown-days');
      var hh = el.querySelector('.js-countdown-hours');
      var mm = el.querySelector('.js-countdown-mins');
      var ss = el.querySelector('.js-countdown-secs');

      if (dd) dd.textContent = String(days).padStart(2, '0');
      if (hh) hh.textContent = String(hours).padStart(2, '0');
      if (mm) mm.textContent = String(mins).padStart(2, '0');
      if (ss) ss.textContent = String(secs).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  });

  // =========================================
  // PRODUCT GALLERY + VARIANT SELECTION
  // =========================================
  // Gallery and variant logic for the product page lives in
  // sections/main-product.liquid (inline <script>).

  // =========================================
  // PRODUCT ACCORDION
  // =========================================

  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      var content = item.querySelector('.accordion-content');
      var isOpen = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.accordion-item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var c = openItem.querySelector('.accordion-content');
        if (c) c.style.maxHeight = '0';
      });

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('is-open');
        if (content) content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // =========================================
  // SHOP THE LOOK — Hotspots
  // =========================================

  document.querySelectorAll('.hotspot-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var hotspot = trigger.closest('.hotspot');
      var isOpen = hotspot.classList.contains('is-open');

      document.querySelectorAll('.hotspot.is-open').forEach(function (h) { h.classList.remove('is-open'); });
      if (!isOpen) hotspot.classList.add('is-open');
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.hotspot.is-open').forEach(function (h) { h.classList.remove('is-open'); });
  });

  // =========================================
  // MOBILE BOTTOM NAV ACTIVE STATE
  // =========================================

  var mobileNavItems = document.querySelectorAll('.mobile-nav-item');
  mobileNavItems.forEach(function (item) {
    if (item.getAttribute('href') === window.location.pathname) {
      item.classList.add('is-active');
    }
  });

  // =========================================
  // NEWSLETTER FORM
  // =========================================

  var newsletterForms = document.querySelectorAll('.js-newsletter-form');
  newsletterForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('[type="email"]');
      var successMsg = form.parentElement.querySelector('.footer-newsletter-success');

      if (!emailInput || !emailInput.value) return;

      // Shopify customer newsletter signup
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'contact[email]=' + encodeURIComponent(emailInput.value) + '&contact[tags]=newsletter&form_type=customer'
      }).then(function () {
        form.style.display = 'none';
        if (successMsg) successMsg.style.display = 'block';
      }).catch(function () {
        form.style.display = 'none';
        if (successMsg) successMsg.style.display = 'block';
      });
    });
  });

  // =========================================
  // FILTER BUTTONS (Collection)
  // =========================================

  document.querySelectorAll('.filter-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.filter-group');
      if (group) {
        group.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('is-active'); });
      }
      btn.classList.add('is-active');
    });
  });

  // =========================================
  // ANNOUNCEMENT BAR (optional)
  // =========================================
  var announcementClose = document.querySelector('.js-announcement-close');
  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      var bar = announcementClose.closest('.announcement-bar');
      if (bar) {
        bar.style.height = bar.offsetHeight + 'px';
        requestAnimationFrame(function () {
          bar.style.transition = 'height 0.3s ease';
          bar.style.height = '0';
          bar.style.overflow = 'hidden';
        });
      }
    });
  }

  // =========================================
  // CONTACT FORM
  // =========================================
  var contactForm = document.querySelector('.js-contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      var submitBtn = contactForm.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
      }
    });
  }

  // =========================================
  // INITIAL CART COUNT
  // =========================================
  getJSON('/cart.js', function (cart) {
    var count = cart.item_count;
    document.querySelectorAll('.js-cart-badge, .cart-badge, .cart-count-badge').forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  });

  // =========================================
  // PRODUCT CARD — MOBILE IMAGE SLIDER (dot sync)
  // =========================================
  document.querySelectorAll('.js-pcm-slides').forEach(function (slides) {
    var card = slides.closest('.product-card-media');
    if (!card) return;
    var dots = card.querySelectorAll('.pcm-dot');
    if (!dots.length) return;

    var slideEls = slides.querySelectorAll('.pcm-slide');

    function syncDot() {
      // Mobile only — desktop uses opacity transitions, so width is constant
      var idx = Math.round(slides.scrollLeft / slides.clientWidth);
      if (idx < 0) idx = 0;
      if (idx >= dots.length) idx = dots.length - 1;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    var rafId;
    slides.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(syncDot);
    }, { passive: true });

    // Prevent the inner anchor click from firing during a swipe
    var startX = 0, startY = 0, moved = false;
    slideEls.forEach(function (slide) {
      slide.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        moved = false;
      }, { passive: true });
      slide.addEventListener('touchmove', function (e) {
        if (Math.abs(e.touches[0].clientX - startX) > 8 ||
            Math.abs(e.touches[0].clientY - startY) > 8) {
          moved = true;
        }
      }, { passive: true });
      slide.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      });
    });
  });

  // =========================================
  // WISHLIST (localStorage based)
  // =========================================
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('avero_wishlist') || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem('avero_wishlist', JSON.stringify(list));
    updateWishlistBadge();
  }
  function updateWishlistBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('.js-wishlist-badge').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  function syncWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('.js-card-wishlist').forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      var on = list.indexOf(pid) !== -1;
      btn.classList.toggle('is-wishlisted', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // Delegated click — works even on dynamically rendered cards
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-card-wishlist');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var pid = btn.getAttribute('data-product-id');
    if (!pid) return;
    var list = getWishlist();
    var idx = list.indexOf(pid);
    if (idx === -1) {
      list.push(pid);
      btn.classList.add('is-wishlisted');
      btn.setAttribute('aria-pressed', 'true');
      if (window.averoToast) window.averoToast('Added to wishlist');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('is-wishlisted');
      btn.setAttribute('aria-pressed', 'false');
      if (window.averoToast) window.averoToast('Removed from wishlist');
    }
    saveWishlist(list);
  });

  syncWishlistButtons();
  updateWishlistBadge();

  // =========================================
  // WISHLIST DRAWER
  // =========================================
  var wishlistDrawer = document.getElementById('wishlist-drawer');
  var wishlistOverlay = document.querySelector('.js-wishlist-drawer-overlay');
  var wishlistItemsEl = document.querySelector('.js-wishlist-drawer-items');
  var wishlistEmptyEl = document.querySelector('.js-wishlist-drawer-empty');
  var wishlistCountEl = document.querySelector('.js-wishlist-drawer-count');

  function openWishlistDrawer() {
    if (!wishlistDrawer) return;
    renderWishlistDrawer();
    wishlistDrawer.classList.add('is-open');
    if (wishlistOverlay) wishlistOverlay.classList.add('is-open');
    wishlistDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeWishlistDrawer() {
    if (!wishlistDrawer) return;
    wishlistDrawer.classList.remove('is-open');
    if (wishlistOverlay) wishlistOverlay.classList.remove('is-open');
    wishlistDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderWishlistDrawer() {
    if (!wishlistItemsEl) return;
    var ids = getWishlist();
    wishlistItemsEl.innerHTML = '';

    if (wishlistCountEl) {
      wishlistCountEl.textContent = ids.length + ' ' + (ids.length === 1 ? 'item' : 'items');
    }

    if (!ids.length) {
      if (wishlistEmptyEl) wishlistEmptyEl.style.display = 'block';
      wishlistItemsEl.style.display = 'none';
      return;
    }
    if (wishlistEmptyEl) wishlistEmptyEl.style.display = 'none';
    wishlistItemsEl.style.display = '';

    ids.forEach(function (id) {
      // Use predictive search to resolve product by id (storefront can't fetch by id directly)
      fetch('/search/suggest.json?q=' + encodeURIComponent('id:' + id) + '&resources[type]=product&resources[limit]=1')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var p = data && data.resources && data.resources.results && data.resources.results.products && data.resources.results.products[0];
          if (!p) return;
          var item = document.createElement('div');
          item.className = 'wd-item';
          item.setAttribute('data-id', id);
          item.innerHTML =
            '<a class="wd-item-img" href="' + p.url + '">' +
              (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="wd-item-body">' +
              '<div>' +
                '<a class="wd-item-title" href="' + p.url + '">' + (p.title || '') + '</a>' +
                '<div class="wd-item-price">' + (p.price || '') + '</div>' +
              '</div>' +
              '<div class="wd-item-actions">' +
                '<a class="wd-item-view" href="' + p.url + '">View</a>' +
                '<button type="button" class="wd-item-remove" data-id="' + id + '" aria-label="Remove">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>';
          wishlistItemsEl.appendChild(item);
        })
        .catch(function () {});
    });
  }

  // Open/close triggers
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-wishlist-drawer-trigger')) {
      e.preventDefault();
      openWishlistDrawer();
      return;
    }
    if (e.target.closest('.js-wishlist-drawer-close') || e.target.closest('.js-wishlist-drawer-overlay')) {
      closeWishlistDrawer();
      return;
    }
    // Remove item from drawer
    var removeBtn = e.target.closest('.wd-item-remove');
    if (removeBtn) {
      e.preventDefault();
      var rid = removeBtn.getAttribute('data-id');
      var list = getWishlist().filter(function (x) { return x !== rid; });
      saveWishlist(list);
      syncWishlistButtons();
      renderWishlistDrawer();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wishlistDrawer && wishlistDrawer.classList.contains('is-open')) {
      closeWishlistDrawer();
    }
  });

  // =========================================
  // NOTIFY-ME MODAL (sold-out cards)
  // =========================================
  var notifyModal = document.getElementById('notify-me-modal');
  var notifyForm = document.getElementById('notify-me-modal-form');
  var notifyEmail = document.getElementById('notify-me-modal-email');
  var notifyTitle = document.getElementById('notify-me-modal-title');
  var notifyProductInput = document.getElementById('notify-me-modal-product');
  var notifySuccess = document.getElementById('notify-me-modal-success');
  var notifyError = document.getElementById('notify-me-modal-error');

  function openNotify(productTitle, productUrl) {
    if (!notifyModal) return;
    if (notifyTitle) notifyTitle.textContent = productTitle || 'this product';
    if (notifyProductInput) notifyProductInput.value = (productTitle || '') + ' — ' + (productUrl || '');
    if (notifySuccess) notifySuccess.style.display = 'none';
    if (notifyError) notifyError.style.display = 'none';
    if (notifyEmail) notifyEmail.value = '';
    notifyModal.setAttribute('aria-hidden', 'false');
    notifyModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { notifyEmail && notifyEmail.focus(); }, 80);
  }
  function closeNotify() {
    if (!notifyModal) return;
    notifyModal.setAttribute('aria-hidden', 'true');
    notifyModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('.js-notify-me-open');
    if (opener) {
      e.preventDefault();
      openNotify(
        opener.getAttribute('data-product-title'),
        opener.getAttribute('data-product-url')
      );
      return;
    }
    if (e.target.closest('.js-notify-me-close') ||
        (notifyModal && e.target === notifyModal)) {
      closeNotify();
    }
  });

  if (notifyForm) {
    notifyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = notifyEmail ? notifyEmail.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (notifyError) {
          notifyError.textContent = 'Please enter a valid email address.';
          notifyError.style.display = 'block';
        }
        return;
      }
      if (notifyError) notifyError.style.display = 'none';
      var submitBtn = notifyForm.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

      var body = 'form_type=contact' +
        '&contact[email]=' + encodeURIComponent(email) +
        '&contact[tags]=back-in-stock' +
        '&contact[body]=' + encodeURIComponent(
          'Back in Stock Notification\n' +
          'Product: ' + ((notifyProductInput && notifyProductInput.value) || '')
        );

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      })
      .then(function () {
        if (notifySuccess) notifySuccess.style.display = 'block';
        if (submitBtn) { submitBtn.textContent = 'Subscribed!'; }
        setTimeout(function () {
          closeNotify();
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Notify Me'; }
        }, 1500);
      })
      .catch(function () {
        if (notifyError) {
          notifyError.textContent = 'Something went wrong. Please try again.';
          notifyError.style.display = 'block';
        }
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Notify Me'; }
      });
    });
  }

})();

/* ===== Extracted from layout/theme.liquid (inline <script> blocks) ===== */

// Redirect /collections index to /collections/all
if (typeof window !== 'undefined' && (window.location.pathname === '/collections' || window.location.pathname === '/collections/')) {
  window.location.replace('/collections/all');
}

(function(){
  // Mobile side menu
  var hamburger = document.getElementById('wb-hamburger');
  var mobileMenu = document.getElementById('wb-mobile-menu');
  var mobileOverlay = document.getElementById('wb-mobile-menu-overlay');
  var mobileClose = document.getElementById('wb-mobile-close');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileOverlay) {
      mobileOverlay.classList.add('is-open');
      mobileOverlay.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('wb-mobile-menu-open');
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileOverlay) {
      mobileOverlay.classList.remove('is-open');
      mobileOverlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('wb-mobile-menu-open');
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  if (mobileMenu) {
    mobileMenu.querySelectorAll('.js-wb-mobile-dropdown').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var submenu = btn.nextElementSibling;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !isOpen);
        if (submenu) submenu.classList.toggle('is-open');
      });
    });
  }

  // Mobile search overlay
  var searchBtn = document.getElementById('wb-mobile-search');
  var searchOverlay = document.getElementById('mobile-search-overlay');
  var searchClose = document.getElementById('mobile-search-close');
  var searchInput = document.getElementById('MobileSearchInput');
  if (searchBtn && searchOverlay) {
    searchBtn.addEventListener('click', function() {
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { searchInput && searchInput.focus(); }, 100);
    });
    searchClose && searchClose.addEventListener('click', function() {
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
    searchOverlay.addEventListener('click', function(e) {
      if (e.target === searchOverlay) {
        searchOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  // Inventory cache
  window.averoInventory = window.averoInventory || {};
  window.averoSetInventory = function(variantId, info) {
    if (!variantId) return;
    window.averoInventory[String(variantId)] = info;
  };
  window.averoInventoryMax = function(variantId) {
    var info = window.averoInventory[String(variantId)];
    if (!info) return null;
    if (info.track !== 'shopify') return null;
    return Math.max(0, parseInt(info.max, 10) || 0);
  };
  window.averoCartQtyForVariant = function(variantId) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var total = 0;
        (cart.items || []).forEach(function(it){
          if (String(it.variant_id) === String(variantId)) total += it.quantity;
        });
        return total;
      })
      .catch(function(){ return 0; });
  };

  // Toast notifications
  window.averoToast = function(message, type) {
    var toast = document.getElementById('avero-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.className = 'avero-toast' + (type === 'error' ? ' is-error' : '');
    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 3000);
  };

  // Quick-add click handler
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-quick-add');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    e.stopPropagation();

    var trackAttr = btn.getAttribute('data-inventory-track');
    if (trackAttr && window.averoSetInventory) {
      window.averoSetInventory(variantId, {
        max: parseInt(btn.getAttribute('data-inventory-max'), 10) || 0,
        track: trackAttr,
        policy: btn.getAttribute('data-inventory-policy')
      });
    }

    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var max = window.averoInventoryMax(variantId);
    var precheck = (max == null)
      ? Promise.resolve(true)
      : window.averoCartQtyForVariant(variantId).then(function(inCart) {
          if (inCart + 1 > max) {
            window.averoToast(
              max === 0 ? 'Out of stock' : 'Only ' + max + ' available — already in your bag',
              'error'
            );
            btn.textContent = origText;
            btn.disabled = false;
            return false;
          }
          return true;
        });

    precheck.then(function(ok) {
      if (!ok) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.textContent = origText;
        btn.disabled = false;
        if (data.title) {
          window.averoToast(data.title + ' added to bag');
          var trigger = document.querySelector('.js-cart-drawer-trigger');
          if (trigger) trigger.click();
        } else if (data.description) {
          window.averoToast(data.description, 'error');
        }
      })
      .catch(function() {
        btn.textContent = origText;
        btn.disabled = false;
        window.averoToast('Something went wrong', 'error');
      });
    });
  });
})();
